import Element, { ElementType } from './element';
import { Hinge } from './hinge';
import { HelpPoint, HelpPointType } from './helpPoint';

class HingesManager {

    private elements!: Element[];

    public initialize(elements: Element[]) {
        this.elements = elements;
    }

    public getHinges(front: Element): Hinge[] {
        const body = this.elements.find((x) => x.type === ElementType.BODY)!;
        const helpPoints = front.helpPoints;
        if (!helpPoints.length) { return []; }
        if (!helpPoints[0].isVertical) { return []; }
        if (front.shape.x < front.slot.shape.x) {
            return front.position.x > front.slot.position.x ?
                this.rights() :
                this.lefts();
        }
        if (front.position.x > body.shape.x / 2) {
            return this.rights();
        }
        return this.lefts();
    }

    public getHingesForHelpPoint(helpPoint: HelpPoint): Hinge[] {
        if (helpPoint.type === HelpPointType.LEFT) {
            return this.rights();
        }
        if (helpPoint.type === HelpPointType.RIGHT) {
            return this.lefts();
        }
        return [];
    }

    private lefts(): Hinge[] {
        return [this.left(true), this.left(false)];
    }

    private rights(): Hinge[] {
        return [this.right(true), this.right(false)];
    }

    private left(down: boolean): Hinge {
        return new Hinge(
            'zawias_L.gltf',
            'zawias_L_mesh_light.jpg',
            down,
        );
    }

    private right(down: boolean): Hinge {
        return new Hinge(
            'zawias_P.gltf',
            'zawias_P_mesh_light.jpg',
            down,
        );
    }
}

export const hingesManager = new HingesManager();
